import React, { useState, useEffect } from 'react'

const SimpleCountdown = ({ start, onComplete }) => {
  const [count, setCount] = useState(start)

  useEffect(() => {
    const timer = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer) // Stop when countdown reaches 0
          if (onComplete) onComplete() // Trigger callback if provided
          return 0
        }
        return prevCount - 1 // Decrease by 1
      })
    }, 1000)

    return () => clearInterval(timer) // Cleanup interval on component unmount
  }, [onComplete])

  return <span>{count}</span>
}

export default SimpleCountdown
